import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../services/userService';
import AuthLayout from '../components/auth/AuthLayout';
import PasswordRequirements from '../components/auth/PasswordRequirements';
import { isPasswordValid as checkPassword } from '../components/auth/passwordRules';
import Alert from '../components/ui/Alert';
import Button from '../components/ui/Button';
import Dialog from '../components/ui/Dialog';
import { FormField, Input, Select } from '../components/ui/Field';
import { toUpperText } from '../utils/formatters';
const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    personType: 'PF',
    cpfCnpj: '',
    role: 'OPERADOR',
    secretaria: '',
    parlamentarId: ''
  });

  const ROLES = [
    { value: 'OPERADOR',   label: 'Operador' },
    { value: 'ANALISTA',   label: 'Analista' },
    { value: 'JURIDICO',   label: 'Jurídico' },
    { value: 'ORCAMENTO',  label: 'Orçamento' },
    { value: 'SECRETARIA', label: 'Secretaria' },
    { value: 'CONVENIOS',  label: 'Convênios' },
    { value: 'CAMARA',     label: 'Câmara Municipal' },
    { value: 'VEREADOR',   label: 'Parlamentar' },
  ];
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const navigate = useNavigate();
  const isPasswordValid = checkPassword(formData.password);
  const validateCPF = (cpf: string): boolean => {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(cpf)) return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (sum % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(9))) return false;
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (sum % 11);
    if (rev === 10 || rev === 11) rev = 0;
    return rev === parseInt(cpf.charAt(10));
  };
  const validateCNPJ = (cnpj: string): boolean => {
    cnpj = cnpj.replace(/[^\d]/g, '');
    if (cnpj.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(cnpj)) return false;
    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    const digits = cnpj.substring(size);
    let sum = 0; let pos = size - 7;
    for (let i = size; i >= 1; i--) { sum += parseInt(numbers.charAt(size - i)) * pos--; if (pos < 2) pos = 9; }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;
    size++; numbers = cnpj.substring(0, size); sum = 0; pos = size - 7;
    for (let i = size; i >= 1; i--) { sum += parseInt(numbers.charAt(size - i)) * pos--; if (pos < 2) pos = 9; }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return result === parseInt(digits.charAt(1));
  };
  const formatCPF = (v: string) => { const n = v.replace(/\D/g,''); if(n.length<=3)return n; if(n.length<=6)return n.slice(0,3)+'.'+n.slice(3); if(n.length<=9)return n.slice(0,3)+'.'+n.slice(3,6)+'.'+n.slice(6); return n.slice(0,3)+'.'+n.slice(3,6)+'.'+n.slice(6,9)+'-'+n.slice(9,11); };
  const formatCNPJ = (v: string) => { const n = v.replace(/\D/g,''); if(n.length<=2)return n; if(n.length<=5)return n.slice(0,2)+'.'+n.slice(2); if(n.length<=8)return n.slice(0,2)+'.'+n.slice(2,5)+'.'+n.slice(5); if(n.length<=12)return n.slice(0,2)+'.'+n.slice(2,5)+'.'+n.slice(5,8)+'/'+n.slice(8); return n.slice(0,2)+'.'+n.slice(2,5)+'.'+n.slice(5,8)+'/'+n.slice(8,12)+'-'+n.slice(12,14); };
  const isCpfCnpjValid = () => { const c = formData.cpfCnpj.replace(/\D/g,''); return formData.personType==='PF'?validateCPF(c):validateCNPJ(c); };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'cpfCnpj') {
      setFormData(prev => ({ ...prev, [name]: formData.personType==='PF'?formatCPF(value):formatCNPJ(value) }));
    } else if (name === 'personType') {
      setFormData(prev => ({ ...prev, [name]: value, cpfCnpj: '' }));
    } else if (name === 'name') {
      setFormData(prev => ({ ...prev, [name]: toUpperText(value) }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); setError(''); setLoading(true);
    if (!formData.cpfCnpj) { setError('Por favor, informe o '+(formData.personType==='PF'?'CPF':'CNPJ')); setLoading(false); return; }
    if (!isCpfCnpjValid()) { setError((formData.personType==='PF'?'CPF':'CNPJ')+' inv\u00e1lido'); setLoading(false); return; }
    if (!isPasswordValid) { setError('A senha n\u00e3o atende aos requisitos m\u00ednimos de seguran\u00e7a'); setLoading(false); return; }
    if (formData.password !== formData.confirmPassword) { setError('As senhas n\u00e3o coincidem'); setLoading(false); return; }
    try {
      const d = formData.cpfCnpj.replace(/\D/g,'');
      await register({
        username: formData.name,
        email: formData.email,
        password: formData.password,
        cpf: formData.personType === 'PF' ? d : null,
        cnpj: formData.personType === 'PJ' ? d : null,
        nomeCompleto: formData.name,
        role: formData.role,
        secretaria: formData.role === 'SECRETARIA' ? formData.secretaria : null,
        parlamentarId: formData.role === 'VEREADOR' ? formData.parlamentarId : null,
      });
      setShowSuccessModal(true);
    } catch (err: any) {
      const msg = err?.response?.data?.error || err?.response?.data || err?.message || 'Erro ao realizar cadastro. Tente novamente.';
      setError(String(msg)); setLoading(false);
    }
  };
  const handleSuccessModalClose = () => { setShowSuccessModal(false); navigate('/login'); };

  const isPF = formData.personType === 'PF';
  const passwordsMismatch = formData.confirmPassword.length > 0 && formData.password !== formData.confirmPassword;

  return (
    <AuthLayout
      title="Criar nova conta"
      subtitle={(
        <>
          Já tem uma conta?{' '}
          <Link to="/login" className="font-medium text-link transition hover:text-link-hover">Fazer login</Link>
        </>
      )}
    >
      <div className="space-y-4">
        {error && <Alert variant="danger">{error}</Alert>}
        <form className="space-y-4" onSubmit={handleSubmit}>
          <FormField htmlFor="name" label="Nome completo">
            <Input id="name" name="name" type="text" required maxLength={256} value={formData.name} onChange={handleChange} placeholder="Nome completo" />
          </FormField>
          <FormField htmlFor="personType" label="Tipo de Pessoa">
            <Select id="personType" name="personType" fieldWidth="lg" value={formData.personType} onChange={handleChange}>
              <option value="PF">Pessoa Física (CPF)</option>
              <option value="PJ">Pessoa Jurídica (CNPJ)</option>
            </Select>
          </FormField>
          <FormField htmlFor="cpfCnpj" label={isPF ? 'CPF' : 'CNPJ'}>
            <Input
              id="cpfCnpj"
              name="cpfCnpj"
              type="text"
              required
              fieldWidth={isPF ? 'md' : 'lg'}
              value={formData.cpfCnpj}
              onChange={handleChange}
              maxLength={isPF ? 14 : 18}
              placeholder={isPF ? '000.000.000-00' : '00.000.000/0000-00'}
            />
          </FormField>
          <FormField htmlFor="email-address" label="E-mail">
            <Input id="email-address" name="email" type="email" autoComplete="email" required value={formData.email} onChange={handleChange} placeholder="seu@email.com" />
          </FormField>
          <FormField htmlFor="password" label="Senha">
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              value={formData.password}
              onChange={handleChange}
              onFocus={() => setPasswordFocused(true)}
              onBlur={() => setPasswordFocused(false)}
              placeholder="Crie uma senha forte"
            />
          </FormField>
          {(passwordFocused || formData.password.length > 0) && <PasswordRequirements password={formData.password} />}
          <FormField
            htmlFor="confirm-password"
            label="Confirmar senha"
            error={passwordsMismatch ? 'As senhas não coincidem' : undefined}
          >
            <Input
              id="confirm-password"
              name="confirmPassword"
              type="password"
              autoComplete="new-password"
              required
              invalid={passwordsMismatch}
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Repita a senha"
            />
          </FormField>
          <Button
            type="submit"
            fullWidth
            loading={loading}
            disabled={!isPasswordValid || formData.password !== formData.confirmPassword}
          >
            {loading ? 'Cadastrando...' : 'Cadastrar'}
          </Button>
        </form>
      </div>

      <Dialog
        open={showSuccessModal}
        title="Cadastro realizado com sucesso!"
        actions={<Button fullWidth onClick={handleSuccessModalClose}>OK</Button>}
      >
        <p>Você receberá um e-mail para ativar sua conta.</p>
        <p>Após a ativação, será possível realizar o login.</p>
      </Dialog>
    </AuthLayout>
  );
};
export default RegisterPage;
